export const WORKSUITE_BRAND = Object.freeze({
  productName: "Worksuite",
  productLine: "Work. Manage. Achieve.",
  loginStatement: "Continue into your working environment.",
  signupStatement: "Begin your working environment.",
  loginAction: "Enter Campaigns",
  signupAction: "Enter Campaigns",
  trustItems: ["Secure", "Private", "Always Yours"],
  homeUrl: process.env.REACT_APP_WORKSUITE_URL || "https://worksuite.clikkle.com",
  loginLogo: "/brands/worksuite/login-logo.png",
  icon: "/brands/worksuite/brand-icon.png",
});
